import React, { memo } from "react";

import { SkeletonLoader } from "@whoosh/design-system/src/components/display";
import {
  Box,
  HStack,
  VStack,
} from "@whoosh/design-system/src/components/primitive";

type Props = {
  isMobile: boolean;
};

const PAYMENT_ROWS = 3;

export const BookingPaymentSkeleton = memo(({ isMobile }: Props) => (
  <Box
    testID="booking-summary-skeleton-payment"
    backgroundColor="surface-primary"
    flexShrink={1}
    flexGrow={1}
    flexBasis={isMobile ? "100%" : 0}
    gap={2}
    borderRadius="4"
    borderColor="outline-default"
    borderWidth={1.5}
    marginTop={8}
    minWidth={isMobile ? "100%" : 368}
    marginLeft={8}
    maxHeight={408}
    paddingTop={6}
    paddingHorizontal={0}
    paddingBottom={5}
  >
    <Box paddingHorizontal={5}>
      <SkeletonLoader
        testID="booking-summary-skeleton-payment-title"
        height={20}
        width={140}
        borderRadius="1"
      />
      <VStack gap={6} marginTop={8}>
        {Array.from({ length: PAYMENT_ROWS }).map((_, idx) => (
          <HStack
            key={`payment-row-${idx}`}
            gap={2}
            justifyContent="space-between"
          >
            <SkeletonLoader
              testID="booking-summary-skeleton-payment-method"
              height={12}
              width={60}
              borderRadius="1"
            />
            <SkeletonLoader
              testID="booking-summary-skeleton-payment-method"
              height={12}
              width={60}
              borderRadius="1"
            />
          </HStack>
        ))}
      </VStack>
    </Box>
    <Box
      height={1}
      width="100%"
      backgroundColor="outline-default"
      marginTop={5}
    />
    <Box paddingHorizontal={5} marginTop={5}>
      <HStack gap={2} justifyContent="space-between">
        <SkeletonLoader
          testID="booking-summary-skeleton-payment-total"
          height={20}
          width={140}
          borderRadius="1"
        />
        <SkeletonLoader
          testID="booking-summary-skeleton-payment-total"
          height={20}
          width={60}
          borderRadius="1"
        />
      </HStack>
    </Box>
    <Box
      height={1}
      width="100%"
      backgroundColor="outline-default"
      marginTop={5}
    />
    <Box alignItems="center" marginTop={5} gap={5} paddingHorizontal={5}>
      <SkeletonLoader
        testID="booking-summary-skeleton-payment-note"
        height={12}
        width={192}
        borderRadius="1"
      />

      <HStack gap={2} justifyContent="space-between" width="100%">
        <Box flex={2}>
          <SkeletonLoader
            testID="booking-summary-skeleton-payment-input"
            height={56}
            width="100%"
            borderRadius="1"
          />
        </Box>
        <Box flex={1}>
          <SkeletonLoader
            testID="booking-summary-skeleton-payment-input"
            height={56}
            width="100%"
            borderRadius="1"
          />
        </Box>
      </HStack>
    </Box>
  </Box>
));
